import { Component, effect, ViewChild } from '@angular/core';
import { ModalWindowComponent } from '../modal-window/modal-window.component';
import { MergeInProgressAlertModalService } from './merge-in-progress-alert-modal.service';

@Component({
  selector: 'ag-shr-merge-in-progress-alert-modal',
  styleUrls: ['./merge-in-progress-alert-modal.component.scss'],
  templateUrl: './merge-in-progress-alert-modal.component.html',
})
export class MergeInProgressAlertModalComponent {
  @ViewChild('mergeAlertModalRef', { static: true })
  private mergeAlertModalRef: ModalWindowComponent;

  constructor(private mergeInProgressAlertModalService: MergeInProgressAlertModalService) {
    effect(() => {
      if (this.mergeInProgressAlertModalService.isOpen()) {
        this.showModal();
      }
    });
  }

  public showModal(): void {
    this.mergeAlertModalRef?.showModal();
  }

  public onModalHiding = (): Promise<boolean> => {
    this.mergeInProgressAlertModalService.close();
    return Promise.resolve(true);
  };
}
